/* eslint-disable no-unused-expressions */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Loading from "../../components/shared/loading/Loading";
import { deleteData } from "../../hooks/delete";
import useFetch from "../../hooks/useFetch";
import { apiPath, clientSideUrl, RoutePath } from "../../utility/Constant";
import ProjectsCard from "./ProjectsCard";
import { arrayMoveImmutable } from "array-move";
import { updateData } from "../../hooks/update";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { MdDragIndicator } from "react-icons/md";
import { motion } from "framer-motion";

const ProjectsContentPage = () => {
  const { projectsApi } = apiPath;
  const { clientOngoingProjects } = clientSideUrl;
  const [apiData, apiLoading] = useFetch(projectsApi);
  const [filteredData, setFilteredData] = useState();
  const [updatedOrder, setUpdatedOrder] = useState(null);

  useEffect(() => {
    setFilteredData(apiData?.filter((item) => item.type !== "banner"));
  }, [apiData]);

  if (apiLoading) {
    return <Loading />;
  }

  async function handleSingleDelete(id) {
    const swalResponse = await Swal.fire({
      title: "Are you sure you want to delete this?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await deleteData(projectsApi, id);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    return swalResponse?.value?._id?.length > 0;
  }

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newOrder = arrayMoveImmutable(filteredData, oldIndex, newIndex);
    setFilteredData(newOrder);
    const payload = newOrder.map((item, idx) => ({
      _id: item._id,
      orderId: idx + 1,
    }));
    setUpdatedOrder(payload);
  };

  const updateOrderToDB = () => {
    updateData("reorder/projects", updatedOrder);
    setTimeout(() => {
      setUpdatedOrder(null);
      window.location.href = "/" + RoutePath.projectsContent;
    }, 800);
  };

  const DragHandle = SortableHandle(() => (
    <div className="absolute top-1 left-1 z-10 bg-white bg-opacity-80 rounded-full p-1">
      <MdDragIndicator className="text-gray-600 cursor-move" size={20} />
    </div>
  ));


  const SortableItem = SortableElement(({ item }) => (
    <ProjectsCard
      key={item._id}
      project={item}
      user="admin"
      handleSingleDelete={handleSingleDelete}
      dragHandle={<DragHandle />}
    />
  ));

  const SortableList = SortableContainer(({ items }) => (
    <div className="select-none grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 md:gap-8">
      <ProjectsCard /> {/* Add new card */}
      {items.map((item, index) => (
        <SortableItem key={item._id} index={index} item={item} />
      ))}
    </div>
  ));

  return (
    <div>
      <div className="mb-8 w-full text-right font-semibold text-sm flex justify-end items-center gap-4">
        {updatedOrder && (
          <motion.button
            onClick={updateOrderToDB}
            type="button"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="btn border-2 text-[#DB0029] font-bold border-[#DB0029] hover:text-white hover:bg-[#DB0029] px-3 py-1.5 rounded-xl"
          >
            Save Changes
          </motion.button>
        )}
        <Link
          className="text-black hover:text-[#DB0029]"
          to={clientOngoingProjects}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit page
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="inline w-4 h-4 ml-1 align-text-top"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </span>
        </Link>
      </div>
      <h1 className="font-bold text-2xl mb-3 mt-6 uppercase">
        Section content
      </h1>
      <SortableList items={filteredData} onSortEnd={onSortEnd} axis="xy" useDragHandle />
    </div>
  );
};

export default ProjectsContentPage;
